import {MoodLightCategory} from 'puffco-api-axios-client';
import React from 'react';

import {moodlightsApi} from '../api/apis';
import {useRemoteData} from '../hooks/useRemoteData';
import {
  upsertAccountMoodLights,
  upsertExclusiveMoodLights,
} from '../redux/slices/moodLightSlice';
import {useAppDispatch} from '../redux/useAppDispatch';

interface Options {
  serialNumber?: string;
}

export const useLoadAccountMoodLights = (options: Options = {}) => {
  const dispatch = useAppDispatch();

  const {isLoading, error, mutate} = useRemoteData(
    {key: 'useLoadAccountMoodLights', ...options},
    () =>
      moodlightsApi
        // TODO: paginate when refactoring UI
        .getMoodLights({
          category: MoodLightCategory.Custom,
          size: 100,
          ...options,
        })
        .then(({data}) => {
          dispatch(upsertAccountMoodLights(data.items));
        }),
  );

  return React.useMemo(
    () => [{isLoading, error}, mutate] as const,
    [isLoading, error, mutate],
  );
};

export const useLoadExclusiveMoodLights = (options: Options = {}) => {
  const dispatch = useAppDispatch();

  const {isLoading, error, mutate} = useRemoteData(
    {key: 'useLoadExclusiveMoodLights', ...options},
    () =>
      moodlightsApi
        // TODO: paginate when refactoring UI
        .getMoodLights({
          category: MoodLightCategory.Exclusive,
          size: 100,
          ...options,
        })
        .then(({data}) => {
          dispatch(upsertExclusiveMoodLights(data.items));
        }),
  );

  return React.useMemo(
    () => [{isLoading, error}, mutate] as const,
    [isLoading, error, mutate],
  );
};
